import { render, staticRenderFns } from "./InfomationDetail.vue?vue&type=template&id=6ee73870&"
import script from "./InfomationDetail.vue?vue&type=script&lang=js&"
export * from "./InfomationDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports